import Reveal from "./Reveal";

const FACTS = [
  { label: "Offices", value: "Panama City · Dallas · Dubai · Madrid" },
  { label: "Founded by", value: "Christophe Suchy and Gail Warrior" },
  { label: "Authors of", value: "The Global Freedom Blueprint" },
  { label: "Method", value: "Seven dimension jurisdictional strategy" },
];

export default function FactsStrip() {
  return (
    <section aria-label="Firm facts" data-testid="facts-strip">
      <div className="container">
        <dl className="facts">
          {FACTS.map((fact, index) => (
            <Reveal
              key={fact.label}
              className="fact"
              delay={index * 0.06}
              data-testid={`fact-${fact.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <dt className="fact-label">{fact.label}</dt>
              <dd className="fact-value">{fact.value}</dd>
            </Reveal>
          ))}
        </dl>
      </div>
    </section>
  );
}
